'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {

	$(document).tooltip({
		items: '.tooltip',
		track: false,
		content: function () {
			return $(this).find('.tooltip-content').html();
		},
		position: {
			my: "center bottom",
			at: "center top-30",
			collision: "none",
			using: function( position, feedback ) {
	        	$( this ).css( position );
	            $( "<div>" )
	              .addClass( "tooltip-arrow" )
	              .addClass( feedback.vertical )
	              .addClass( feedback.horizontal )
	              .appendTo( this );
	        }
		},
		hide: false
	});

	$('.share-link').on('click', function (e) {
		e.preventDefault();
		var target = $(this).data('target');
		if (!target) {
			return;
		}
		$(target).toggleClass('active');
	});
};
